import { styled, Box } from '@mui/material';

export const ScreenWarningContainer = styled(Box)(({ theme }) => ({
  display: 'none',
  [theme.breakpoints.down(1100)]: {
    display: 'flex',
    position: 'fixed',
    flexDirection: 'column',
    inset: 0,
    backgroundColor: theme.palette.background.default,
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(2),
    zIndex: 9999,
    textAlign: 'justify'
  }
}));
